import axios from "axios";

const FORECAST_API_URL =
  import.meta.env.VITE_FORECAST_API_URL || "/api/v1/forecast";

const ForecastApiClient = axios.create({
  baseURL: FORECAST_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

ForecastApiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export const forecastApi = {
  getStatus: () => ForecastApiClient.get("/status"),
  getDimensions: () => ForecastApiClient.get("/dimensions"),
  run: (source = "all", wait = false, hpo = null) =>
    ForecastApiClient.post("/run", null, {
      params: {
        source,
        wait,
        ...(hpo == null ? {} : { hpo }),
      },
    }),
  getHpo: (params = {}) => ForecastApiClient.get("/hpo", { params }),
  runHpo: (source = "all", wait = false, extras = {}) =>
    ForecastApiClient.post("/hpo", null, {
      params: { source, wait, ...extras },
    }),
  runBacktest: (source = "all", wait = false, extras = {}) =>
    ForecastApiClient.post("/backtest", null, {
      params: { source, wait, ...extras },
    }),
  listPlenty: (params = {}) => ForecastApiClient.get("/plenty", { params }),
  listAmazon: (params = {}) => ForecastApiClient.get("/amazon", { params }),
  plentySeries: (params = {}) =>
    ForecastApiClient.get("/plenty/series", { params }),
  amazonSeries: (params = {}) =>
    ForecastApiClient.get("/amazon/series", { params }),
  stockout: (params = {}) => ForecastApiClient.get("/stockout", { params }),
  stockoutSuggest: (params = {}) =>
    ForecastApiClient.get("/stockout/suggest", { params }),
  oosCandidates: (params = {}) =>
    ForecastApiClient.get("/stockout/oos_candidates", { params }),
  accuracy: (params = {}) => ForecastApiClient.get("/accuracy", { params }),
};

export default ForecastApiClient;
